document.addEventListener('DOMContentLoaded', function () {
  console.log('DOMContentLoaded event fired, running inline script.');

  // Retry mechanism for attaching event listeners to buttons
  function attachEventListeners(retries = 5) {
    const transferButton = document.getElementById('transfer-button');
    const creditButton = document.getElementById('credit-button');

    // Transfer Button Redirect
    if (transferButton && !transferButton.hasAttribute('listener-added')) {
      console.log('Transfer button found successfully.');

      transferButton.addEventListener('click', function (event) {
        event.preventDefault();
        console.log('Pago Con Transferencia button clicked.');

        // 🔁 Redirect to custom checkout page
        transferButton.textContent = 'Redirigiendo...';
        transferButton.disabled = true;
        window.location.href = 'https://www.lapshop.cl/pages/bank-transfer-checkout';
      });

      transferButton.setAttribute('listener-added', 'true');
      console.log('Listener added to transfer button.');
    } else if (!transferButton && retries > 0) {
      console.log('Transfer button not found, retrying in 500ms...');
      setTimeout(() => attachEventListeners(retries - 1), 500);
    }

    // Credit Card Button (regular /cart route)
    if (creditButton && !creditButton.hasAttribute('listener-added')) {
      console.log('Credit button found successfully.');

      creditButton.addEventListener('click', function (event) {
        console.log('Pago Con Débito/Crédito button clicked.');
        // Default Shopify cart redirect (no override needed)
      });

      creditButton.setAttribute('listener-added', 'true');
      console.log('Listener added to credit button.');
    } else if (!creditButton && retries > 0) {
      console.log('Credit button not found, retrying in 500ms...');
      setTimeout(() => attachEventListeners(retries - 1), 500);
    }

    if (retries === 0) {
      console.error('Failed to attach event listeners after multiple attempts.');
    }
  }

  // Start binding once DOM is ready
  attachEventListeners();
});
